module.exports = __webpack_public_path__ + "static/media/icon_REPSE.86b9dccd.svg";